// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"baab70e0","453":"29b4a950"}[chunkId] + ".chunk.js";
};